module.exports = __webpack_public_path__ + "img/frb6m.dc337a83.jpg";